import { Outlet } from 'react-router-dom'
import Navbar from '../HomePageComponenets/navbar/Navbar';
import { Container } from './Container'

import { useLocation } from 'react-router-dom';

import { Footer } from './Footer';
import { LetsConnect } from '../HomePageComponenets/LetsConnect/LetsConnect';
const AppLayout = () => {
    const location = useLocation();


  return (
    <>   
          <Container>
            { location.pathname !=="/" && <Navbar />}
           
           {location.pathname === "/pricing" &&  
          <div className='mt-[28vh] bg-black text-center p-5'>
            <h2>Transparent, Usage-Based Pricing</h2>
            <p className='mt-4 md:my-[3vh]'>
              Generous free plans—pay only for what you use, based on Monthly Active Users (MAU).
            </p>

          </div>

      }  
           {location.pathname === "/resources" &&  
          <div className=" text-left bg-black  mt-20 md:mt-[20rem]">
          <h2>Resources</h2>
          <p className="my-6   ">
          Quickstart and build your next web-based multiplayer game with Playroom integrated.
          </p>
      </div>
      }  
          </Container>
         
       
    <Outlet />
    <Container><LetsConnect/></Container>
    <Footer/>
    </>
  )
}

export default AppLayout